import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-db48d76c")

_pushScopeId("data-v-db48d76c")
const _hoisted_1 = { class: "p-16" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Friendly to newbies, Good for Investors with low risk appetite Friendly to newbies, Good for Investors with low risk appetite Friendly to newbies, Good for Investors with low risk appetite.")
const _hoisted_3 = { class: "br-lg mt-16 f-md" }
const _hoisted_4 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "dark" }, [
    /*#__PURE__*/_createVNode("th", { style: {"border-left":"none"} }),
    /*#__PURE__*/_createVNode("th", null, "Low"),
    /*#__PURE__*/_createVNode("th", null, "Moderate"),
    /*#__PURE__*/_createVNode("th", null, "High")
  ])
], -1)
const _hoisted_5 = {
  class: "pl-12 c-title",
  style: {"text-align":"left","border-left":"none"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_Pic = _resolveComponent("Pic")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_t, {
      class: "f-lg",
      style: {"line-height":"24px"},
      path: "leverage_16"
    }, {
      default: _withId(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_Pic, {
      class: "my-8",
      src: "help/leverage_learn",
      style: {"width":"100%"}
    }),
    _createVNode(_component_t, {
      as: "div",
      path: "leverage_17",
      multiline: "",
      custom: ""
    }, {
      default: _withId(({td}) => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(td, (p, index) => {
          return (_openBlock(), _createBlock("p", {
            class: "f-lg mb-8",
            style: {"line-height":"24px"},
            key: index
          }, _toDisplayString(p), 1))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode("table", _hoisted_3, [
      _hoisted_4,
      _createVNode("tbody", null, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
          return (_openBlock(), _createBlock("tr", {
            key: index,
            class: {'dark': index%2==1}
          }, [
            _createVNode("td", _hoisted_5, _toDisplayString(item.title), 1),
            _createVNode("td", null, _toDisplayString(item.low), 1),
            _createVNode("td", null, _toDisplayString(item.moderate), 1),
            _createVNode("td", null, _toDisplayString(item.high), 1)
          ], 2))
        }), 128))
      ])
    ])
  ]))
})